import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { FormFields } from '../../AccountForm.meta';
import { getIsOwnerTrust } from '../../utils/getIsOwnerTrust';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { WorkflowIdEnum } from '../../../../../../../../Workflow/api/useWorkflowDataQuery';
import { useAccountFormContext } from '../../context/useAccountFormContext';

interface Props {
  isDefaultExcluded?: boolean;
}

export const GrossEstateCheckbox = ({ isDefaultExcluded }: Props) => {
  const formBag = useFormContext<FormFields>();

  const {
    options: { OwnerOptions },
  } = useAccountFormContext();

  const ownerModel = formBag.watch('bankAccount.OwnerModel');

  const isOwnerTrust =
    ownerModel.length === 1 ? getIsOwnerTrust(ownerModel[0].Name, OwnerOptions) : false;

  const routeParams = useRouteParams();

  if (isOwnerTrust) {
    return null;
  }

  if (routeParams.workflowId !== WorkflowIdEnum.EstatePlanning.toString()) {
    return null;
  }

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.IncludeInGrossEstate"
      render={({ field }) => (
        <Checkbox
          checked={
            isDefaultExcluded ? !!field.value : field.value === undefined ? false : !field.value
          }
          onChange={evt =>
            field.onChange(isDefaultExcluded ? evt.target.checked : !evt.target.checked)
          }
        >
          {isDefaultExcluded ? 'Include in Gross Estate' : 'Exclude from Gross Estate'}
        </Checkbox>
      )}
    />
  );
};
